export default {"src":"/_next/static/media/x-blu.c1c29794.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};